import API from '../../apiConfig';
export const postRegistration = async (data) => {
  const response = await API.post('supplier/registration', data, { withCredentials: false });
  return response;
};
